<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'DocumentTypeList' }" class="mb-1 btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <DocumentTypeForm
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import DocumentTypeForm from './Form'
// import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('documenttype/create')

export default {
  components: {
    DocumentTypeForm,
    Loader
  },

  data () {
    return {
      item: {
        accessType: 0,
        caseTypesAllowed: [],
        rolesToViewAllowed: []
      }
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },
  // beforeCreate () {
  //  checkPagePermission('configuration', 'DocumentTypeCreate')
  // },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.push({ name: 'DocumentTypeList' })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),
    onSendForm () {
      let item = this.item
      if (item.version) {
        item.version = parseInt(item.version)
      }
      if (item.ordering) {
        item.ordering = parseInt(item.ordering)
      }
      this.create(item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
